import { Link } from 'react-router-dom';

interface Tournament {
  id: number;
  title: string;
  game: string;
  image: string;
  date: string;
  status: string;
  prize: string;
  teams: string[];
  viewers: string;
  slug: string;
}

export default function TournamentSection({ tournaments }: { tournaments: Tournament[] }) {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              热门赛事
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              全球顶级电竞赛事实时追踪，不错过任何精彩对决
            </p>
          </div>
          <Link
            to="/category/all"
            className="text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部赛事 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {tournaments.slice(0, 6).map((t) => (
            <Link
              key={t.id}
              to={`/category/${t.game === '英雄联盟' ? 'lol' : t.game === '王者荣耀' ? 'hok' : t.game.toLowerCase()}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={t.image}
                  alt={t.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${
                    t.status === 'live'
                      ? 'bg-red-500 text-white'
                      : 'bg-accent-500 text-background-50'
                  }`}>
                    {t.status === 'live' ? '进行中' : '即将开始'}
                  </span>
                </div>
                <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm px-2.5 py-1 rounded-full">
                  <span className="text-white text-xs font-medium">{t.game}</span>
                </div>
              </div>

              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {t.title}
                </h3>

                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {t.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {t.viewers}
                  </span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1.5">
                    {t.teams.slice(0, 3).map((team, i) => (
                      <span
                        key={i}
                        className="px-2 py-0.5 bg-background-100 rounded text-xs text-foreground-700"
                      >
                        {team}
                      </span>
                    ))}
                    {t.teams.length > 3 && (
                      <span className="text-xs text-foreground-400">+{t.teams.length - 3}</span>
                    )}
                  </div>
                  <span className="text-xs font-semibold text-accent-600">
                    {t.prize}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}